import {
  sendDeleteRequest,
  sendGetRequest,
  sendPostRequest,
  sendPutRequest
} from '../requests';
import {CreateUserProps, GetUserProps} from '../../constants/types';

const baseUrl = '/users';
const tenantsUrl = '/tenants';
const userProfileUrl = '/users/authorized/profile';

export const getUsers = (params: GetUserProps) =>
  sendGetRequest(baseUrl, params);

export const addUser = (data: CreateUserProps) =>
  sendPostRequest(baseUrl, data);

export const addTenantUser = (data: CreateUserProps) =>
  sendPostRequest(`${tenantsUrl}${baseUrl}`, data);

export const updateUserById = (entity: string, body: object) =>
  sendPutRequest(`${baseUrl}/${entity}`, body);

export const deleteUserById = (entity: string) =>
  sendDeleteRequest(`${baseUrl}/${entity}`);

export const deleteTenantUserById = (entity: string) =>
  sendDeleteRequest(`${tenantsUrl}${baseUrl}/${entity}`);

export const lockUser = (entity: string) =>
  sendPutRequest(`${baseUrl}/${entity}/lock`);

export const unlockUser = (entity: string) =>
  sendPutRequest(`${baseUrl}/${entity}/unlock`);

export const lockTenantUser = (entity: string) =>
  sendPutRequest(`${tenantsUrl}${baseUrl}/${entity}/lock`);

export const unlockTenantUser = (entity: string) =>
  sendPutRequest(`${tenantsUrl}${baseUrl}/${entity}/unlock`);

export const getCurrentUser = () =>
  sendGetRequest(userProfileUrl);

export const updateUserEmail = (params) =>
  sendPostRequest(`${userProfileUrl}/send-change-email-notification`, null, params);

export const updateCurrentUser = (body) =>
  sendPutRequest(userProfileUrl, body);

export const addTenantsToUser = (id: string, body: number[]
) => sendPostRequest(`${baseUrl}/${id}/tenants`, body);

export const addGroupsToUser = (id: string, body: number[]
) => sendPostRequest(`${baseUrl}/${id}/groups`, body);


export const addTenantUserToGroups = (id: string, body: number[]
) => sendPostRequest(`${tenantsUrl}${baseUrl}/${id}/groups`, body);

export const removeTenantFromUser = (
    userId: string,
    tenantId: number
) => sendDeleteRequest(`${baseUrl}/${userId}/tenants/${tenantId}`);

export const removeGroupFromUser = (
    userId: string,
    groupId: number
) => sendDeleteRequest(`${baseUrl}/${userId}/groups/${groupId}`);

export const removeTenantUserFromGroup = (
    userId: string,
    groupId: number
) => sendDeleteRequest(`${tenantsUrl}${baseUrl}/${userId}/groups/${groupId}`);

export const addTenantsToUserGroup =
  (id: string, groupId: string, body: number[]) =>
    sendPostRequest(`${baseUrl}/${id}/groups/${groupId}/tenants`, body);
